/**
 *  When action execution is triggered, open response
 *  container to height specified by this variable.
 */
export const ActionExecutionResizerHeight = (window.innerHeight * 30) / 100;
